import { useLayoutEffect } from 'react'

import { useLocation, useNavigationType } from 'react-router-dom'

export const ScrollToTop = (): null => {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useLayoutEffect((): void => {
    if (hash) return
    if (navigationType === 'POP') return

    // #root is the scroll container (sized by @knap-ai/widget's global CSS),
    // not the window — so resetting it is what scrolls back to the top.
    document.getElementById('root')?.scrollTo(0, 0)
    window.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, hash])

  return null
}
